export const deliveryOrderFields = [
  {
    label: 'ID',
    key: 'row_id.value',
  },
  {
    label: 'No. Pengiriman',
    key: 'number',
  },
  {
    label: 'Nama Pelanggan',
    key: 'customer.value',
  },
  {
    label: 'Karyawan Pemasaran',
    key: 'marketing_user.value',
  },
  {
    label: 'Target Diambil',
    key: 'expected_pickup_on.value',
  },
  {
    label: 'Target Terkirim',
    key: 'expected_delivered_on.value',
  },
  {
    label: 'No. AJU',
    key: 'aju_number.value',
  },
  {
    label: 'No. Shipment',
    key: 'shipment_number.value',
  },
  {
    label: 'No. Referensi',
    key: 'reference_number.value',
  },
  {
    label: 'Catatan Lainnya',
    key: 'note.value',
  },
  {
    label: 'Alamat Asal',
    key: 'origin_address.value',
  },
  {
    label: 'Alamat Tujuan',
    key: 'destination_address.value',
  },
  {
    label: 'Jenis Box',
    key: 'box_type.value',
  },
  {
    label: 'ID Group',
    key: 'group_id.value',
  }
].map((field) => {
  const newField = {
    ...field,
    isSortable: true,
    showErrorKey: field.key.replace('.value', ''),
    thAttr: {
      style: 'min-width:180px;',
    },
  }

  if (field.key === 'row_id.value') {
    newField.isSortable = false
  }

  return newField
})

export const loadFields = [
  {
    label: 'ID',
    key: 'row_id.value',
  },
  {
    label: 'Nama Produk',
    key: 'product.value',
  },
  {
    label: 'Kuantitas',
    key: 'quantity.value',
  },
  {
    label: 'Satuan Kuantitas',
    key: 'uom.value',
  },
  {
    label: 'Catatan',
    key: 'note.value',
  },
].map((field) => {
  const newField = {
    ...field,
    isSortable: true,
    showErrorKey: field.key.replace('.value', ''),
    thAttr: {
      style: 'min-width:180px;',
    },
  }

  if (field.key === 'row_id.value') {
    newField.isSortable = false
  }

  return newField
})
